module.exports = __webpack_public_path__ + "static/media/ICONS_CONCEPTO LAB.f0beb489.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_CONCEPTO LAB.svg
// module id = 481
// module chunks = 0